(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Komforcik-main-product"]) return;
  try {
    
  if (!customElements.get('kmf-product')) {
    customElements.define(
      'kmf-product',
      class KmfProduct extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.initGallery();
          this.initVariants();
          this.initSizeFinder();
          this.initDialogs();
        }

        /* ── Galeria ── */
        initGallery() {
          this.gallery = this.querySelector('[data-kmf-gallery]');
          this.thumbs = Array.from(this.querySelectorAll('[data-kmf-thumb]'));
          this.thumbList = this.querySelector('[data-kmf-thumbs]');
          if (!this.gallery) return;

          this.thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => this.goToSlide(parseInt(thumb.dataset.kmfThumb, 10)));
          });
          const prev = this.querySelector('[data-kmf-gal-prev]');
          const next = this.querySelector('[data-kmf-gal-next]');
          if (prev) prev.addEventListener('click', () => this.goToSlide((this.gallery.index || 0) - 1));
          if (next) next.addEventListener('click', () => this.goToSlide((this.gallery.index || 0) + 1));

          this.gallery.addEventListener('kmf:slide', (event) => this.markThumb(event.detail.index));
        }

        goToSlide(index) {
          if (this.gallery && typeof this.gallery.go === 'function') this.gallery.go(index);
        }

        markThumb(index) {
          this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
          const active = this.thumbs[index];
          if (!active || !this.thumbList) return;
          const item = active.parentElement;
          const left = item.offsetLeft - this.thumbList.offsetLeft - (this.thumbList.clientWidth - item.clientWidth) / 2;
          this.thumbList.scrollTo({ left: left, behavior: 'smooth' });
        }

        /* ── Warianty ── */
        initVariants() {
          this.variantsRoot = this.querySelector('[data-kmf-variants]');
          if (!this.variantsRoot) return;
          const json = this.variantsRoot.querySelector('[data-kmf-variants-json]');
          try {
            this.variants = JSON.parse(json.textContent);
          } catch (error) {
            this.variants = [];
          }
          this.groups = Array.from(this.variantsRoot.querySelectorAll('[data-kmf-option]'));
          this.variantsRoot.addEventListener('change', (event) => {
            if (event.target.matches('[data-kmf-option-input]')) this.onVariantChange();
          });
          this.initCalculator();
        }

        selectedOptions() {
          return this.groups.map((group) => {
            const select = group.querySelector('select[data-kmf-option-input]');
            if (select) return select.value;
            const checked = group.querySelector('input[data-kmf-option-input]:checked');
            return checked ? checked.value : null;
          });
        }

        onVariantChange() {
          const selected = this.selectedOptions();
          this.groups.forEach((group, i) => {
            const label = group.querySelector('[data-kmf-selected]');
            if (label && selected[i] != null) label.textContent = selected[i];
          });

          const variant = this.variants.find((candidate) =>
            candidate.options.every((value, i) => value === selected[i])
          );
          const button = this.querySelector('[data-kmf-atc]');
          const buttonText = this.querySelector('[data-kmf-atc-text]');

          if (!variant) {
            if (button) button.disabled = true;
            if (buttonText) buttonText.textContent = this.dataset.unavailableLabel || 'Niedostępne';
            return;
          }

          const input = this.querySelector('form[action*="/cart/add"] input[name="id"]');
          if (input) {
            input.value = variant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (button) {
            button.disabled = !variant.available;
            if (variant.available) button.removeAttribute('data-unavailable');
            else button.setAttribute('data-unavailable', 'true');
          }
          if (buttonText && button) {
            buttonText.textContent = variant.available ? button.dataset.label : button.dataset.soldOutLabel;
          }

          if (window.history && window.history.replaceState) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }

          if (variant.featured_media && this.gallery) {
            const slides = Array.from(this.gallery.querySelectorAll('.kmf-gal__slide'));
            const index = slides.findIndex((slide) => slide.dataset.mediaId === String(variant.featured_media.id));
            if (index > -1) this.goToSlide(index);
          }

          this.refreshPrice(variant.id);
        }

        refreshPrice(variantId) {
          const target = this.querySelector('[data-kmf-price]');
          if (!target || !this.dataset.url) return;
          const requested = String(variantId);
          this.pendingVariant = requested;
          fetch(`${this.dataset.url}?variant=${requested}&section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((html) => {
              if (this.pendingVariant !== requested) return;
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fresh = doc.querySelector('[data-kmf-price]');
              if (fresh) target.innerHTML = fresh.innerHTML;
            })
            .catch(() => {});
        }

        /* ── Kalkulator rozmiaru (obwód + miseczka = rozmiar) ── */
        initCalculator() {
          const calc = this.variantsRoot.querySelector('[data-kmf-calc]');
          const chartSource = this.variantsRoot.querySelector('[data-kmf-chart]');
          if (!calc || !chartSource) return;
          const band = calc.querySelector('[data-kmf-band]');
          const cup = calc.querySelector('[data-kmf-cup]');
          const result = calc.querySelector('select[data-kmf-option-input]');
          const message = this.variantsRoot.querySelector('[data-kmf-calc-message]');
          if (!band || !cup || !result) return;

          const chart = {};
          chartSource.textContent
            .replace(/\s*(\d+)\s*:/g, '\n$1:')
            .split('\n')
            .forEach((line) => {
              const idx = line.indexOf(':');
              if (idx === -1) return;
              const key = line.slice(0, idx).trim();
              if (!key) return;
              chart[key] = {};
              line
                .slice(idx + 1)
                .split(',')
                .forEach((pair) => {
                  const parts = pair.split('=');
                  if (parts.length !== 2) return;
                  chart[key][parts[0].trim().toUpperCase()] = parts[1].trim().toUpperCase();
                });
            });

          const update = () => {
            if (!band.value || !cup.value) return;
            const size = chart[band.value] && chart[band.value][cup.value.toUpperCase()];
            const option = size
              ? Array.from(result.options).find((item) => item.value.trim().toUpperCase() === size)
              : null;
            if (message) message.hidden = Boolean(option);
            if (!option) return;
            result.value = option.value;
            result.dispatchEvent(new Event('change', { bubbles: true }));
          };
          band.addEventListener('change', update);
          cup.addEventListener('change', update);
        }

        /* ── Znajdź swój rozmiar (obwód pod biustem + obwód w biuście) ── */
        parseChart(text) {
          const chart = {};
          String(text || '')
            .replace(/\s*(\d+)\s*:/g, '\n$1:')
            .split('\n')
            .forEach((line) => {
              const idx = line.indexOf(':');
              if (idx === -1) return;
              const key = line.slice(0, idx).trim();
              if (!key) return;
              chart[key] = {};
              line
                .slice(idx + 1)
                .split(',')
                .forEach((pair) => {
                  const parts = pair.split('=');
                  if (parts.length !== 2) return;
                  chart[key][parts[0].trim().toUpperCase()] = parts[1].trim().toUpperCase();
                });
            });
          return chart;
        }

        initSizeFinder() {
          this.querySelectorAll('[data-kmf-finder]').forEach((root) => {
            const chartSource = root.querySelector('[data-kmf-chart]');
            const configSource = root.querySelector('[data-kmf-finder-config]');
            const under = root.querySelector('[data-kmf-under]');
            const bust = root.querySelector('[data-kmf-bust]');
            const result = root.querySelector('[data-kmf-finder-result]');
            const sizeEl = root.querySelector('[data-kmf-finder-size]');
            const detailEl = root.querySelector('[data-kmf-finder-detail]');
            const noMatch = root.querySelector('[data-kmf-finder-nomatch]');
            if (!chartSource || !under || !bust || !result) return;

            const chart = this.parseChart(chartSource.textContent);
            let config = {};
            try {
              config = JSON.parse(configSource.textContent);
            } catch (error) {
              config = {};
            }
            const cups = (config.cups || ['A', 'B', 'C', 'D', 'E']).map((cup) => String(cup).trim().toUpperCase());

            const update = () => {
              const underValue = parseFloat(String(under.value).replace(',', '.'));
              const bustValue = parseFloat(String(bust.value).replace(',', '.'));
              result.hidden = true;
              if (noMatch) noMatch.hidden = true;
              if (!underValue || !bustValue) return;

              /* Obwód: zaokrąglenie do najbliższych 5 cm. Miseczka: różnica obwodów, co 2 cm od 12 cm (pierwsza miseczka). */
              const band = String(Math.round(underValue / 5) * 5);
              const difference = bustValue - underValue;
              const cupIndex = Math.max(0, Math.floor((difference - 12) / 2));
              const cup = difference >= 8 && cupIndex < cups.length ? cups[cupIndex] : null;
              const size = cup && chart[band] ? chart[band][cup] : null;

              if (!size) {
                if (noMatch) noMatch.hidden = false;
                return;
              }
              sizeEl.textContent = size;
              if (detailEl) {
                detailEl.textContent = (config.bandLabel || '') + ' ' + band + ', ' + (config.cupLabel || '') + ' ' + cup;
              }
              result.hidden = false;

              const select = this.querySelector('select[data-kmf-option-input]');
              if (select) {
                const option = Array.from(select.options).find((item) => item.value.trim().toUpperCase() === size);
                if (option && select.value !== option.value) {
                  select.value = option.value;
                  select.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            };
            under.addEventListener('input', update);
            bust.addEventListener('input', update);

            const tabs = Array.from(root.querySelectorAll('[data-kmf-tab]'));
            const panels = Array.from(root.querySelectorAll('[data-kmf-panel]'));
            tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                tabs.forEach((item) => {
                  const active = item === tab;
                  item.classList.toggle('is-active', active);
                  item.setAttribute('aria-selected', active ? 'true' : 'false');
                });
                panels.forEach((panel) => {
                  panel.hidden = panel.dataset.kmfPanel !== tab.dataset.kmfTab;
                });
              });
            });
          });
        }

        /* ── Okna dialogowe ── */
        initDialogs() {
          this.addEventListener('click', (event) => {
            const opener = event.target.closest('[data-kmf-dialog-open]');
            if (opener) {
              const dialog = document.getElementById(opener.dataset.kmfDialogOpen);
              if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
              return;
            }
            const dialog = event.target.closest('dialog.kmf-dialog');
            if (!dialog) return;
            if (event.target.closest('[data-kmf-dialog-close]') || event.target === dialog) dialog.close();
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Komforcik-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kmf-reviews-more]');
    if (!button) return;
    const root = document.getElementById(button.dataset.kmfReviewsMore);
    if (!root) return;
    const grid = root.querySelector('.kmf-rv__grid');
    const step = parseInt((grid && grid.dataset.limit) || '6', 10) || 6;
    const hidden = root.querySelectorAll('.kmf-rv__card--hidden');
    Array.from(hidden)
      .slice(0, step)
      .forEach((card) => card.classList.remove('kmf-rv__card--hidden'));
    if (hidden.length <= step) button.parentElement.remove();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Komforcik-video-slider"] && !Shopify.designMode) return;
  try {
    
  /* <kmf-slider> — wspólny slider (scroll-snap) używany też przez sekcje
     „Komforcik opinie slider” i „Komforcik produkt” (galeria). */
  if (!customElements.get('kmf-slider')) {
    customElements.define(
      'kmf-slider',
      class KmfSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-kmf-track]');
          if (!this.track) return;
          this.slides = Array.from(this.track.children);
          this.prev = this.querySelector('[data-kmf-prev]');
          this.next = this.querySelector('[data-kmf-next]');
          this.dots = this.querySelector('[data-kmf-dots]');
          this.index = 0;
          this.autoplayVideo = this.dataset.autoplayVideo === 'true';

          if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1));
          if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1));

          let ticking = false;
          this.track.addEventListener(
            'scroll',
            () => {
              if (ticking) return;
              ticking = true;
              requestAnimationFrame(() => {
                ticking = false;
                this.sync();
              });
            },
            { passive: true }
          );
          window.addEventListener('resize', () => this.build());

          this.addEventListener('click', (event) => {
            const play = event.target.closest('[data-kmf-play]');
            const frame = event.target.closest('.kmf-vs__frame');
            if (!frame) return;
            const video = frame.querySelector('video');
            if (!video) return;
            if (play || event.target === video) this.toggle(video);
          });
          this.querySelectorAll('video').forEach((video) => {
            const frame = video.closest('.kmf-vs__frame');
            if (!frame) return;
            video.addEventListener('play', () => frame.classList.add('is-playing'));
            video.addEventListener('pause', () => frame.classList.remove('is-playing'));
          });

          if ('IntersectionObserver' in window) {
            this.visible = false;
            new IntersectionObserver(
              (entries) => {
                this.visible = entries[0].isIntersecting;
                this.handleVideos();
              },
              { threshold: 0.35 }
            ).observe(this);
          } else {
            this.visible = true;
          }

          this.build();
        }

        perView() {
          if (!this.slides.length) return 1;
          const slideWidth = this.slides[0].getBoundingClientRect().width || 1;
          return Math.max(1, Math.round(this.track.clientWidth / slideWidth));
        }

        pages() {
          return Math.max(1, this.slides.length - this.perView() + 1);
        }

        build() {
          if (this.dots) {
            const total = this.pages();
            if (this.dots.childElementCount !== total) {
              this.dots.innerHTML = '';
              for (let i = 0; i < total; i += 1) {
                const dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'kmf-slider__dot';
                dot.tabIndex = -1;
                dot.addEventListener('click', () => this.go(i));
                this.dots.appendChild(dot);
              }
            }
          }
          this.sync();
        }

        go(index) {
          const max = this.pages() - 1;
          const target = Math.min(Math.max(index, 0), max);
          const slide = this.slides[target];
          if (!slide) return;
          this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        }

        sync() {
          const left = this.track.scrollLeft;
          let best = 0;
          let distance = Infinity;
          this.slides.forEach((slide, i) => {
            const d = Math.abs(slide.offsetLeft - this.track.offsetLeft - left);
            if (d < distance) {
              distance = d;
              best = i;
            }
          });
          const max = this.pages() - 1;
          const changed = best !== this.index;
          this.index = Math.min(best, max);
          if (this.prev) this.prev.disabled = this.index <= 0;
          if (this.next) this.next.disabled = this.index >= max;
          if (this.dots) {
            Array.from(this.dots.children).forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
          }
          if (changed) {
            this.handleVideos();
            this.dispatchEvent(new CustomEvent('kmf:slide', { detail: { index: this.index } }));
          }
        }

        toggle(video) {
          if (video.paused) {
            this.querySelectorAll('video').forEach((other) => {
              if (other !== video) other.pause();
            });
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }

        handleVideos() {
          const per = this.perView();
          this.slides.forEach((slide, i) => {
            const video = slide.querySelector('video');
            if (!video) return;
            const inView = this.visible && i >= this.index && i < this.index + per;
            if (!inView) {
              video.pause();
            } else if (this.autoplayVideo && video.paused) {
              video.muted = true;
              video.play().catch(() => {});
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
